var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 121,
    viewBox: "0 0 181 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5136 18.1483V103.308C33.1112 99.6248 18.9282 83.8236 17.1011 64.9498H33.9568V84.2973H42.3124V37.1593H33.9568V56.5068H17.1011C18.9282 37.633 33.1112 21.8318 51.5136 18.1483ZM162.931 56.5068C161.104 37.633 146.926 21.8318 128.528 18.1483V103.308C146.926 99.6248 161.104 83.828 162.931 64.9498H146.08V84.2973H137.725V37.1593H146.08V56.5068H162.931ZM87.705 32.3601L87.5648 32.4752L87.5867 32.4973C81.1371 40.0902 77.2332 49.9543 77.2332 60.7261C77.2332 72.2726 81.8776 83.4517 90.0141 91.5847C98.155 83.4517 102.799 72.277 102.799 60.7261C102.799 52.0972 100.214 43.6232 95.4559 36.4952L101.45 30.4386C107.724 39.2269 111.155 49.8614 111.155 60.7261C111.155 74.3845 105.972 87.1839 96.525 96.9329C103.553 101.644 111.698 104.127 120.177 104.127V17.3248C107.22 17.3248 95.583 23.16 87.705 32.3601ZM180.041 60.4162V61.036C180.041 94.1526 153.472 121 120.698 121H59.3434C26.5696 121 0 94.157 0 61.036V60.4162C0 27.2996 26.5696 0.452171 59.3434 0.452171H120.698C153.472 0.452171 180.041 27.2996 180.041 60.4162ZM171.502 60.7261C171.502 32.1387 148.486 8.88184 120.194 8.88184C109.249 8.88184 98.8385 12.3175 90.0185 18.8212C81.1985 12.3175 70.7879 8.88184 59.8517 8.88184C31.5601 8.88184 8.54398 32.1387 8.54398 60.7261C8.54398 89.3135 31.5601 112.57 59.8517 112.57C67.5325 112.57 75.1081 110.817 81.9915 107.483L75.6514 101.077C70.6477 103.078 65.2672 104.127 59.8648 104.127V17.3248C68.3387 17.3248 76.4752 19.8085 83.5075 24.5192C74.0653 34.2683 68.8864 47.0633 68.8864 60.7261C68.8864 89.3135 91.9025 112.57 120.194 112.57C148.486 112.57 171.502 89.3135 171.502 60.7261Z",
    fill: "url(#paint0_linear_3474_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3474_4",
    x1: 0,
    y1: 60.7261,
    x2: 180.041,
    y2: 60.7261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DBDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#067D71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41c244e394d71070ce19459d953bdaaf.svg";
export { ForwardRef as ReactComponent };